import { AxiosResponse } from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { BASE_METHODS } from "../../constants/action-types";
import { CreatePrivacyPolicyDTO } from "../../constants/dto/privacy-policy";
import {
  addPrivacyPolicyToPrivacyPolicies,
  setPrivacyPolicyActionStart,
  setPrivacyPolicyErrorMessage,
} from "../../constants/reducers/privacy-policy.reducer";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { store } from "../../store";
import { createCall } from "../base";

let requestBody: CreatePrivacyPolicyDTO;

export const createPrivacyPolicy = async () => {
  store.dispatch(setPrivacyPolicyActionStart(true));
  const { text } = store.getState().privacyPolicy;

  const request = await createCall(
    "cms/privacy-policies/create",
    BASE_METHODS.POST,
    "application/json",
    "1.0.0",
    { text },
    undefined,
  );

  try {
    const response = request as AxiosResponse;
    requestBody = plainToClass(CreatePrivacyPolicyDTO, response.data);
    const errors = await validate(requestBody);
    if (errors.length > 0) {
      store.dispatch(
        setPrivacyPolicyErrorMessage(
          TextEnum.CREATE_PRIVACY_POLICY_INVALID_RESPONSE,
        ),
      );
      return null;
    }
    store.dispatch(
      addPrivacyPolicyToPrivacyPolicies({
        privacyPolicy: response.data.privacyPolicy,
      }),
    );
    return response;
  } catch (error) {
    store.dispatch(setPrivacyPolicyActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
